export const meta: BlockMeta = {
  title: "Grid Rows",
  description: "A stack of rows in a 2 or 3 column grid",
  keywords: ["content"],
  cache: false,
  tags: ["root"],
  conditions: {
    postTypes: ["page", "post", "article", "hall-of-fame"],
  },
  icon: "book-alt",
  category: "layouts",
}

import { defineBlock, InnerBlocks } from "eddev/blocks"
import { tv } from "tailwind-variants"

const variants = tv({
  base: "",
  variants: {
    admin: {
      true: "[&_>_.block-editor-inner-blocks_>_div]:!grid [&_>_.block-editor-inner-blocks_>_div]:!gap-5 [&_>_.block-editor-inner-blocks_>_div]:!m-0",
      false: "grid gap-5",
    },
    columns: {
      "2": "grid-cols-1 md:grid-cols-2 [&_>_.block-editor-inner-blocks_>_div]:!grid-cols-1 md:[&_>_.block-editor-inner-blocks_>_div]:!grid-cols-2",
      "3": "grid-cols-1 md:grid-cols-3 [&_>_.block-editor-inner-blocks_>_div]:!grid-cols-1 md:[&_>_.block-editor-inner-blocks_>_div]:!grid-cols-3",
    },
  },
  defaultVariants: {
    admin: false,
    columns: "3",
  },
})

export default defineBlock("content/grid-rows", (props) => {
  return (
    <div className={variants({ admin: env.admin, columns: props.columns })}>
      <InnerBlocks
        allowedBlocks={["content/grid-rows-item"]}
        template={[
          ["content/grid-rows-item", null],
          ["content/grid-rows-item", null],
          ["content/grid-rows-item", null],
        ].slice(0, parseInt(props.columns))}
        orientation="horizontal"
      />
    </div>
  )
})
